import { ColumnDef } from "@tanstack/react-table";
import { useMemo } from "react";
import { useParams } from "react-router-dom";

import { Task } from "~/api/Api";
import { PAGE_TITLES } from "~/configs/pageTitles";
import { usePageTitle } from "~/hooks/usePageTitle";
import { routes } from "~/router";

import LinksTasksPage, {
  InternalLinkCell,
  StatusBadge,
} from "./LinksTasksPage";
import styles from "./OutreachLinksPage.module.scss";

const OutreachLinksPage = () => {
  usePageTitle(PAGE_TITLES.communityLinks);
  const { id: siteId } = useParams();

  const columns = useMemo<ColumnDef<Task>[]>(
    () => [
      {
        accessorKey: "status",
        header: "Status",
        enableSorting: false,
        cell: (info) => (
          <StatusBadge status={info.getValue() as string} styles={styles} />
        ),
      },
      {
        accessorKey: "link_title",
        header: "Site",
        cell: (info) => {
          const task = info.row.original;

          return (
            <InternalLinkCell
              to={routes.site.links.outreachTask({
                id: String(siteId),
                taskId: task.id,
              })}
              domain={task.link_domain}
              styles={styles}
            >
              {task.link_title || "No title"}
            </InternalLinkCell>
          );
        },
      },
      {
        accessorKey: "link_domain",
        header: "Domain",
      },
      {
        accessorKey: "category",
        header: "Category",
        cell: (info) => (info.getValue() as string) || "-",
      },
      {
        id: "keyword_name",
        accessorKey: "focus_keyword",
        header: "Focus keyword",
        cell: (info) => (info.getValue() as string) || "No keyword",
      },
    ],
    [siteId],
  );

  return (
    <LinksTasksPage
      title={PAGE_TITLES.communityLinks}
      description="Community citations help expand your visibility through relevant discussions, forums, and question-and-answer platforms, often used as input for both Google and LLM model training and agents."
      siteId={siteId}
      taskType="OutreachLink"
      dfyLink={{
        label: "Done-For-You Community Links",
        to: routes.services.communityLinks(),
      }}
      searchRansackKey="link_domain_or_link_title_or_category_or_keyword_name_i_cont"
      primarySort="reddit_first ASC"
      columns={columns}
      styles={styles}
    />
  );
};

export default OutreachLinksPage;
